import { of as observableOf, Observable, BehaviorSubject } from 'rxjs'
import { Injectable } from '@angular/core'
import { Permissions } from '@exchange/domain/.'
import { mergeMap } from 'rxjs/operators'
import { AuthService, IUser } from 'ng-client-auth'

@Injectable()
export class SessionService {
  private _propertiesChangedSource = new BehaviorSubject<boolean>(false)

  public propertiesChanged = this._propertiesChangedSource.asObservable()

  private _user: IUser

  constructor(private authService: AuthService) {}

  public getCurrentUser(): Observable<IUser> {
    return this.authService.getAppUserInfo()
  }

  public isPasswordValid(): Observable<boolean> {
    if (this._user) {
      return observableOf(!this._user.MustChangePwd)
    }
    return this.getCurrentUser().pipe(
      mergeMap(user => {
        return observableOf(!user.MustChangePwd)
      })
    )
  }

  public isPermissionGranted(permission: Permissions): Observable<boolean> {
    const p = permission as number
    if (this._user) {
      return observableOf((this._user.Permissions || []).indexOf(p) > -1)
    }
    return this.getCurrentUser().pipe(
      mergeMap(user => {
        return observableOf((user.Permissions || []).indexOf(p) > -1)
      })
    )
  }

  public anyPermissionGranted(permissions: Permissions[]): Observable<boolean> {
    const p = permissions.map(x => x as number)
    if (this._user) {
      const userPermissions = this._user.Permissions || []
      const isGranted = p.some(x => userPermissions.indexOf(x) > -1)
      return observableOf(isGranted)
    }
    return this.getCurrentUser().pipe(
      mergeMap(user => {
        const userPermissions = user.Permissions || []
        const isGranted = p.some(x => userPermissions.indexOf(x) > -1)
        return observableOf(isGranted)
      })
    )
  }
}
